import i18n from "../i18n";
import config from "../config";

// Язык создателя пробрасывается в URL получателя через ?lang=ru|en.
// detectUrlLang в i18n.js принимает только короткие коды, поэтому нормализуем.
export default function buildInviteLink(link) {
  if (!link) return `${config.generatedBaseLink}?link=`;
  const raw = (i18n.language || "").toLowerCase();
  const lang = raw.startsWith("ru") ? "ru" : "en";
  return `${config.generatedBaseLink}?link=${link}&lang=${lang}`;
}
